import { useRef, useEffect } from 'react';
import { getTradingNumericParameters } from './TradingNumericUtils';
import { ticksUtils } from '@shared/utils/Trading/TicksUtils';
import { OffsetModeViewEnum } from '@shared/utils/Trading/OffsetModeViewEnum';
export const useTradingNumericBase = ({ value, variableTickList, incrementInTicks, offsetType }) => {
    const lastValidPriceRef = useRef(isValidNumber(value) ? value : 0);
    useEffect(() => {
        if (isValidNumber(value)) {
            lastValidPriceRef.current = value;
        }
    }, [value]);
    const onIncrement = (price) => {
        if (!isValidNumber(price)) {
            return lastValidPriceRef.current;
        }
        const isFractionalTicksAllowed = offsetType === OffsetModeViewEnum.TicksFractionalForForex;
        return ticksUtils.CalculatePrice(price, incrementInTicks, variableTickList, isFractionalTicksAllowed, offsetType);
    };
    const onDecrement = (price) => {
        if (!isValidNumber(price)) {
            return lastValidPriceRef.current;
        }
        const isFractionalTicksAllowed = offsetType === OffsetModeViewEnum.TicksFractionalForForex;
        return ticksUtils.CalculatePrice(price, -incrementInTicks, variableTickList, isFractionalTicksAllowed, offsetType);
    };
    const numericParams = getTradingNumericParameters(variableTickList, isValidNumber(value) ? value : lastValidPriceRef.current);
    return {
        min: numericParams.min,
        max: numericParams.max,
        precision: numericParams.precision,
        onIncrement,
        onDecrement
    };
};
